<div class="assets-management__folder">
    <span class="overlap-text truncate-3" [matTooltip]="name">{{name}}</span>
</div>
